<template>
  <v-dialog
    width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        v-bind="attrs"
        :disabled="!html"
        v-on="on"
      >
        preview
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Preview corpo email:</v-card-title>
      <iframe
        id="preview"
        sandbox="allow-popups"
        frameborder="0"
        width="100%"
        height="600"
        :srcdoc="html"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewCodeModal',
  props: {
    value: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    html() {
      return this.value;
    },
  },
};
</script>
